import React, { useCallback, useEffect, useRef, useState } from "react";

import { useSelector } from "react-redux";

import "../css/CreateTwitterDestination.css";
import {
    authorizeTwitter,
    getTwitterAuthUrl,
} from "../helpers/destinations/createDestination";
import LoginButton from "./molecules/LoginButton";
import SwalAlertComp from "./SwalAlert";

const CreateTwitterDestinationPopup = (props) => {
    const {
        setModalLoading,
        setIsAuthData,
        setIsOauthData,
        type: destinationType,
    } = props;
    const [isLoading, setIsLoading] = useState(false);
    const twitterOAuthStateRef = useRef(null);
    const language = useSelector((state) => state.languagesState.languages);

    useEffect(() => {
        setModalLoading?.(isLoading);
    }, [isLoading, setModalLoading]);

    const fetchTwitterAuthUrl = useCallback(async () => {
        const result = await getTwitterAuthUrl();
        if (!result?.status || !result?.data?.url) {
            return null;
        }
        twitterOAuthStateRef.current = result.data.state;
        return result;
    }, []);

    const twitterAuthorizeCall = async (oauthParams) => {
        setIsLoading(true);
        const data = {
            oauth: {
                oauth_token: oauthParams.oauth_token,
                oauth_verifier: oauthParams.oauth_verifier,
                state: twitterOAuthStateRef.current,
            },
            destination_type: destinationType,
        };
        const response = await authorizeTwitter(data);
        if (response.status) {
            setIsAuthData?.(response);
            setIsOauthData?.(data);
            setModalLoading?.(false);
        } else {
            SwalAlertComp({
                title: language?.delete_swal_modal?.failed ?? "Failed",
                message: response?.message ?? "",
                icon: "error",
            });
            setModalLoading?.(false);
        }
        setIsLoading(false);
    };

    return (
        <div className="position-relative overflow-hidden z-1">
            <LoginButton
                getAuthUrl={fetchTwitterAuthUrl}
                getAuthUrlResponseTransform={(response) => {
                    return response?.data?.url;
                }}
                paramNames={["oauth_token", "oauth_verifier"]}
                onSuccess={twitterAuthorizeCall}
                dataTransform={(params) => ({
                    oauth_token: params.oauth_token,
                    oauth_verifier: params.oauth_verifier,
                })}
                logoSrc="/assets/images/typeImages/tw-white-icon.png"
                buttonText={
                    language?.destination_modal?.sign_in_twitter ??
                    "Continue with X (Twitter)"
                }
                isLoadingExternal={isLoading}
                className="twitter-btn"
            />
        </div>
    );
};

export default CreateTwitterDestinationPopup;
